<template>
    <v-card class="mx-auto" light >
        <v-toolbar flat >
            <v-btn icon large @click="$router.go(-1)"><v-icon color="blue-grey">mdi-arrow-left-bold</v-icon></v-btn> 
        </v-toolbar>
        
        <v-card
            max-width="600"
            class="mx-auto"
            elevation="4"
            :loading="loading"
        >
            <v-toolbar flat dense dark color="blue-grey darken-1">
                <v-toolbar-title>{{dependencia.nombre}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <div class="font-weight-bold">
                Titular: {{dependencia.titular.usuario.titulo}} {{dependencia.titular.usuario.nombreCompleto}}
                </div>
                {{dependencia.titular.puesto}}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text v-if="dependencia.integrantes.length == 0"><i>No se han capturado integrantes...</i></v-card-text>
            <v-list two-line v-else>
                <v-subheader>Integrantes:</v-subheader>
                <v-list-item v-for="(integrante, index) in dependencia.integrantes" :key="index">
                    <v-list-item-content>
                        <v-list-item-title>{{integrante.usuario.titulo}} {{integrante.usuario.nombreCompleto}}</v-list-item-title>
                        <v-list-item-subtitle>{{integrante.puesto}}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-btn icon @click="quitarUsuario(integrante.usuario._id)">
                            <v-icon color="grey lighten-1">mdi-close-circle</v-icon>
                        </v-btn>
                    </v-list-item-action>

                </v-list-item>
            </v-list>
            <v-card-actions>
                <v-btn small  color="blue-grey"  dark
                    @click="mostrarAsignar=true"
                    >Agregar</v-btn>
            </v-card-actions>
        </v-card>
        <div style="padding:20px">
            <logs :logs="logs"></logs>
        </div>

        <asignar-integrante 
            v-if="mostrarAsignar"
            :mostrar="mostrarAsignar"
            :dependencia="id"
            @cancelar="mostrarAsignar=false"
            @usuarioAgregado="usuarioAgregado"
        />

    <v-card-actions>
    </v-card-actions>

    </v-card>      
</template>

<script>

import axios from 'axios'
import { mapGetters} from 'vuex'
import AsignarIntegrante from '../components/dependencias/asignarIntegrante'
import logs from '../components/logs/logs.vue'
export default {
    components:{
        AsignarIntegrante,
        logs
    },
    data: () => ({
        loading: false,
        id: null,
        dependencia: { 
            titular: { usuario: {}},
            integrantes: []
        },
        mostrarAsignar: false,
        logs:[]
    }),
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ])
    },
    created(){
        this.loading = true;
        this.id = this.$route.params.id;
        axios.get(this.httpURL+'/dependencia/'+this.id,
            {headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                if( res.data.ok ){
                    this.dependencia = res.data.dependencia;
                    this.logs = res.data.logs
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                }
                this.loading = false;
            })
            .catch(error => {
                // console.log('Error: '+error);
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                this.loading = false;
            });
    },
    methods:{
        usuarioAgregado({integrantes, log}){
            this.dependencia.integrantes = integrantes;
            this.logs.unshift(log)
            this.mostrarAsignar = false;
        },
        quitarUsuario(id){
            this.loading = true;
            this.id = this.$route.params.id;
            axios.delete(this.httpURL+'/dependencia/'+this.id+'/'+id,
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        let index = this.dependencia.integrantes.findIndex(x=>x.usuario._id == id);
                        if( index >= 0 )
                            this.dependencia.integrantes.splice(index,1);
                        this.logs.unshift(res.data.log)
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                    this.loading = false;
                });
        }
    }
}
</script>
